export default __webpack_public_path__ + "static/media/bird2.86997302.svg";